import type { AboutLink, LinkItem, NavItem } from '../types/content';

export const mainNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Destinations', to: '/destinations', menu: 'destinations', match: ['/destinations'] },
  { label: 'Programmes', to: '/programmes', menu: 'programmes', match: ['/programmes'] },
  { label: 'About Us', to: '/about/who-we-are', menu: 'about', match: ['/about', '/blog', '/price-list'] },
  { label: 'Contact Us', to: '/contact', match: ['/contact'] },
];

export const aboutLinks: AboutLink[] = [
  { label: 'Who We Are', to: '/about/who-we-are' },
  { label: 'Teaching Methodology', to: '/about/teaching-methodology' },
  { label: 'ES Blog', to: '/blog' },
  { label: 'Careers', to: '/about/careers' },
  { label: 'ES Helps', to: '/about/es-helps', comingSoon: true },
];

export const priceListLinks: LinkItem[] = [
  { label: 'Price List - Dubai', to: '/price-list/dubai' },
  { label: 'Price List - London', to: '/price-list/london' },
  { label: 'Price List - Camps', to: '/price-list/camps' },
];

export const resourceLinks: LinkItem[] = [...priceListLinks, { label: 'Media', to: '/about/media' }];

export const policyLinks: LinkItem[] = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
  { label: 'Delivery Policy', to: '/delivery-policy' },
  { label: 'Refund Policy', to: '/refund-policy' },
];
